import React, { createContext, useContext } from 'react';
import { useWeb3React } from '@web3-react/core';

// Define the context type
interface Web3ContextType {
  connector: ReturnType<typeof useWeb3React>['connector'];
  hooks: ReturnType<typeof useWeb3React>['hooks'];
}

// Create the context with a default value (optional)
const Web3Context = createContext<Web3ContextType | null>(null);

// Custom provider component
export const Web3Provider = ({ children }: { children: React.ReactNode }) => {
  const { connector, hooks } = useWeb3React();

  return (
    <Web3Context.Provider value={{ connector, hooks }}>
      {children}
    </Web3Context.Provider>
  );
};

// Custom hook to access the context
export const useWeb3 = () => {
  const context = useContext(Web3Context);
  if (!context) {
    throw new Error('useWeb3 must be used within a Web3Provider');
  }
  return context;
};